import script from "./PremiumPhonesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PremiumPhonesPage.vue?vue&type=script&lang=ts&setup=true"

import "./PremiumPhonesPage.vue?vue&type=style&index=0&id=e5be1152&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5be1152"]])

export default __exports__